import api from "../libs/api";

export default {
	postWorkflow: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post("/workflows", data)
				.then(({ status, data }) => {
					if (status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteWorkflow: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/workflows/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateWorkflow: (id, data) => {
		return new Promise((resolve, reject) => {
			api()
				.put(`/workflows/${id}`, data)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getWorkflowDetails: (id) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/workflows/${id}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	// getWorkflows: (data) => {
	//   return new Promise((resolve, reject) => {
	//       api()
	//           .get('/workflows')
	//           .then(({ status, data }) => {
	//               if (status === 200) resolve(data);
	//               throw new Error(`Failed with status: ${status}`);
	//           })
	//           .catch(error => reject(error));
	//   });
	// },
	getWorkflowTemplate: (formId) => {
		return new Promise((resolve, reject) => {
			// Changed: Appends ID to URL `/workflow-template/3`
			api()
				.get(`/workflow-template/${formId}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	// updated with searching filters
	// Arrays (e.g. initiator_id) are serialized as key[]=val for Laravel
	getWorkflows: (params) => {
		return new Promise((resolve, reject) => {
			api()
				.get("/workflows", {
					params: {
						...params,
						per_page: params.per_page || 10,
					},
					paramsSerializer: (params) => {
						const parts = [];
						Object.keys(params).forEach((key) => {
							const val = params[key];
							if (val === undefined || val === null || val === '') return;
							if (Array.isArray(val)) {
								val.forEach((v) => {
									parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`);
								});
							} else {
								parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(val)}`);
							}
						});
						return parts.join('&');
					},
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	getCurrentWorkflow: (fi, kk) => {
		return new Promise((resolve, reject) => {
			api()
				.get(`/get-current-workflow/?form_id=${fi}&key=${kk}`)
				.then(({ status, data }) => {
					if (status === 200) resolve(data.data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	updateWorkflowApprovers: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.post(`/update-initiated-workflow`, data)
				.then(({ status, data }) => {
					if (status === 201) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},

	deleteWorkflowGroup: (data) => {
		return new Promise((resolve, reject) => {
			api()
				.delete(`/delete-workflow-approver-group`, {
					headers: {
						Accept: "application/vnd.api+json",
						"Content-Type": "application/x-www-form-urlencoded",
					},
					data: new URLSearchParams(data).toString(),
				})
				.then(({ status, data }) => {
					if (status === 200) resolve(data);
					throw new Error(`Failed with status: ${status}`);
				})
				.catch((error) => reject(error));
		});
	},
};
